export const TIER_MAP = {
  1: {
    name: 'subscriptions.t1.name',
    smallName: 'subscriptions.t1.smallName',
    img: '/tiers/t1.png',
    price: 'subscriptions.t1.price',
    chargedPrice: 'subscriptions.t1.chargedPrice',
    numericalPrice: 'subscriptions.t1.numericalPrice',
  },
  3: {
    name: 'subscriptions.EG_RACER.name',
    smallName: 'subscriptions.EG_RACER.smallName',
    img: '/tiers/EG_RACER.png',
    price: 'subscriptions.EG_RACER.price',
    chargedPrice: 'subscriptions.EG_RACER.chargedPrice',
    tierNumber: '3',
    numericalPrice: 'subscriptions.EG_RACER.numericalPrice',
  },
};

export const CARD_MAP = {
  visa: {
    path: '/Cards/visa.svg',
  },
  'american express': { path: '/Cards/AE.svg' },
  'diners club': {
    path: '/Cards/Diners.svg',
  },
  jcb: { path: '/Cards/JCB.png' },
  mastercard: { path: '/Cards/mastercard.svg' },
  unionpay: { path: '/Cards/CUP.svg' },
};
export const PRODUCT_MAP = {
  EXPLORER: {
    name: 'EXPLORER.name',
    smallName: 'EXPLORER.smallName',
    img: '/tiers/EXPLORER.png',
    price: 'EXPLORER.price',
    chargedPrice: 'EXPLORER.chargedPrice',
    tierNumber: '1',
    numericalPrice: 'EXPLORER.numericalPrice',
  },
  EG_RACER: {
    name: 'EG_RACER.name',
    smallName: 'EG_RACER.smallName',
    img: '/tiers/EG_RACER.png',
    price: 'EG_RACER.price',
    chargedPrice: 'EG_RACER.chargedPrice',
    tierNumber: '3',
    numericalPrice: 'EG_RACER.numericalPrice',
  },
  EG_RACER_2: {
    name: 'EG_RACER.name',
    smallName: 'EG_RACER.smallName',
    img: '/tiers/EG_RACER.png',
    price: 'EG_RACER.price',
    chargedPrice: 'EG_RACER.chargedPrice',
    tierNumber: '3',
    numericalPrice: 'EG_RACER.numericalPrice',
  },
};
export const TIER_FEATURES = {
  '1': { canRealtime: false },
  '3': { canRealtime: true },
};
export const CARD_STATE_KEY = 'addCardState';
export const SUBSCRIPTION_STATE_KEY = 'subscriptionState';
export const paymentData_STATE_KEY = 'paymentDataState';
export const TEIR_DESCRIPTION =
  'You will continue to enjoy the Explorer features until [date], we will then charge your card only 15EGP every month.';

export const NEW_SUB_IFRAME_ID = 44393;
export const NEW_CARD_IFRAME_ID = 77048;
